var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIonicIosExit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 18.45,
    viewBox: "0 0 24 18.45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_ionic-ios-exit",
    "data-name": "Icon ionic-ios-exit",
    transform: "translate(-3.375 -6.75)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_7",
    "data-name": "Trac\\xE9 7",
    d: "M10.125,9.058v6.173h9.7l-2.544-2.763a.792.792,0,0,1,.005-1.062.672.672,0,0,1,.992.006L22,15.45a.791.791,0,0,1,.2.525.76.76,0,0,1-.054.288A.809.809,0,0,1,22,16.5h0l-3.72,4.038a.668.668,0,0,1-.992.006.786.786,0,0,1-.005-1.062l2.544-2.763h-9.7v6.173A2.242,2.242,0,0,0,12.281,25.2H25.219a2.242,2.242,0,0,0,2.156-2.308V9.058A2.242,2.242,0,0,0,25.219,6.75H12.281A2.242,2.242,0,0,0,10.125,9.058Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_8",
    "data-name": "Trac\\xE9 8",
    d: "M4.289,17.086a.914.914,0,0,0,0,1.828h5.836V17.086Z",
    transform: "translate(0 -2.019)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIonicIosExit);
export default __webpack_public_path__ + "static/media/ionic-ios-exit.a34a6f9146434fc121a131c3d0f5b5ab.svg";
export { ForwardRef as ReactComponent };